import * as React from "react";
import { cn } from "@/lib/utils";

export interface SliderProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type" | "value" | "onChange"
> {
  value?: number[];
  onValueChange?: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
}

const Slider = React.forwardRef<HTMLInputElement, SliderProps>(
  (
    {
      className,
      value = [0],
      onValueChange,
      min = 0,
      max = 100,
      step = 1,
      ...props
    },
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = [Number(e.target.value)];
      onValueChange?.(newValue);
    };

    const percentage = ((value[0] - min) / (max - min)) * 100;

    return (
      <div
        className="relative w-full"
        style={{ height: "16px", display: "flex", alignItems: "center" }}
      >
        {/* Background track with gradient */}
        <div
          className="pointer-events-none absolute h-2 w-full rounded-lg"
          style={{
            background: `linear-gradient(to right, #66A0CD ${percentage}%, #0a3a4d ${percentage}%)`,
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
          }}
        />
        <input
          type="range"
          ref={ref}
          className={cn(
            "custom-slider relative z-10 w-full cursor-pointer",
            className
          )}
          value={value[0]}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          style={{
            margin: 0,
            padding: 0,
          }}
          {...props}
        />
      </div>
    );
  }
);
Slider.displayName = "Slider";

export { Slider };
